import * as geohash from 'ngeohash';
import { apiJson } from "./api";

export async function geocodeAddress(address: string): Promise<{ lat: number, lng: number, hash: string } | null> {
  try {
    const response = await apiJson<{ success?: boolean; data?: { lat?: string; lon?: string }[] }>(`/api/geocode?address=${encodeURIComponent(address)}`);
    
    if (response.success && response.data && response.data.length > 0) {
      const lat = parseFloat(response.data[0].lat || "");
      const lng = parseFloat(response.data[0].lon || "");
      const hash = geohash.encode(lat, lng);
      
      return { lat, lng, hash };
    }
  } catch (error) {
    console.error("Geocoding failed", error);
  }
  
  return null;
}
